import {
  V2ListWebhookPublicationsForSubscriptionApiArg,
  useV2ListWebhookPublicationsForSubscriptionQuery,
} from "@generated";
import type { WebhookPublication } from "../types";

export interface UseWebhookPublicationsListArgs {
  webhookSubscriptionId: string;
  page?: V2ListWebhookPublicationsForSubscriptionApiArg["page"];
}

export const useWebhookPublicationsList = ({
  webhookSubscriptionId,
  page,
}: UseWebhookPublicationsListArgs) => {
  const { data, error, isLoading, isFetching, refetch } =
    useV2ListWebhookPublicationsForSubscriptionQuery(
      { webhookSubscriptionId, page },
      { refetchOnMountOrArgChange: true }
    );

  const rows: WebhookPublication[] = (data?.data ?? []).map((pub) => ({
    id: String(pub.id),
    status: pub.attributes?.status ?? "",
    httpStatus: pub.attributes?.["http-status"] ?? null,
    sourceType: pub.attributes?.["source-type"] ?? "",
    sourceId: pub.attributes?.["source-id"] ?? null,
    contents: pub.attributes?.contents ?? null,
    createdAt: pub.attributes?.["created-at"] ?? "",
  }));

  const pageMeta = {
    recordCount: data?.meta?.["record-count"] ?? 0,
    pageCount: data?.meta?.["page-count"] ?? 0,
  };

  return { rows, pageMeta, error, isLoading, isFetching, refetch };
};
